import React, { useState } from 'react';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { CreditCardIssuerType } from 'Jsx/CheckoutV4/types';

import InputField, { ChangeState, Validation } from '../../InputField';

import getCreditCardCVC from './validation/getCreditCardCVC';

export interface CVCState {
  cvc: string;
  isValid: boolean;
}

interface CVCInputProps {
  onCVCChange: (state: CVCState) => void;
  cardIssuer: CreditCardIssuerType | undefined;
  autoFocus?: boolean;
  description?: string;
}

const CVCVInput: React.FC<CVCInputProps> = ({
  onCVCChange,
  cardIssuer,
  autoFocus = false,
  description = '',
}) => {
  const [digits, setDigits] = useState<number>();
  const validateCVC = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Validation => {
    const {
      creditCardCVV,
      creditCardCVVDigits,
      creditCardCVVErrorMessage,
      isCreditCardCVVValid,
    } = getCreditCardCVC({
      eventInput: event,
      creditCardIssuer: cardIssuer,
    });

    setDigits(creditCardCVVDigits);

    return {
      formattedValue: creditCardCVV,
      errorState: {
        message: creditCardCVVErrorMessage,
        error: !isCreditCardCVVValid,
      },
    };
  };

  const onChange = ({ value, isValid }: ChangeState) => {
    onCVCChange({ cvc: value, isValid });
  };

  return (
    <InputField
      autoComplete="cc-csc"
      id="cvc-field"
      name="cvc-field"
      testId="cvc-field"
      type="numeric"
      description={description}
      onChange={onChange}
      validation={validateCVC}
      autoFocus={autoFocus}
      maxLength={digits}
      label={I18N_STRINGS.CVC_CVV_LABEL}
    />
  );
};

export default CVCVInput;
